<mat-sidenav-container>

  <mat-sidenav #sidenav mode="side">
    <mat-toolbar class="sidenav-toolbar">
      <button mat-mini-fab>
        <mat-icon>search</mat-icon>
      </button>
      <input matInput class="example-full-width" type="text" name="searchInput">
      <span class="example-spacer"></span>
    </mat-toolbar>

    <mat-card class="decoration-card">
      <mat-card-content>

        <div *ngIf="currentModelInSelection === 1">
            <mat-list role="list">
              <mat-list-item role="listitem" class="customer-item" *ngFor="let customer of listAllCustomers" (click)="selectCustomer(customer)">
                {{customer.name}}
              </mat-list-item>
            </mat-list>
        </div>

        <div *ngIf="currentModelInSelection === 2">
            <mat-list role="list">
              <mat-list-item role="listitem" class="vessel-item" *ngFor="let vessel of listAllVessel" (click)="selectVessel(vessel)">
                {{vessel.name}}
              </mat-list-item>
            </mat-list>
        </div>

        <div *ngIf="currentModelInSelection === 3">
            <mat-list role="list">
              <mat-list-item role="listitem" class="trail-item" *ngFor="let trail of listAllTrail" (click)="selectTrail(trail)">
                {{trail.name}}
              </mat-list-item>
            </mat-list>
        </div>

        <div *ngIf="currentModelInSelection === 4">
          <mat-list role="list">
            <mat-list-item role="listitem" class="test-item" *ngFor="let test of listAllTest" (click)="selectTest(test)">
              {{test.sn + ". " + test.name}}
            </mat-list-item>
          </mat-list>
        </div>

        <div *ngIf="currentModelInSelection === 5">
          <mat-list role="list">
            <mat-list-item role="listitem" class="step-item" *ngFor="let step of listAllTestStep" (click)="selectTestStep(step)">
              Test step #{{step.sn}}
            </mat-list-item>
          </mat-list>
        </div>

        <div *ngIf="currentModelInSelection === 6">
          <mat-list role="list">
            <mat-list-item role="listitem" class="recommendation-item" *ngFor="let recommendation of listAllRecommendation" (click)="selectRecommendation(recommendation)">
              Recommendation {{recommendation.sn}}
            </mat-list-item>
          </mat-list>
        </div>
        
        <div *ngIf="currentModelInSelection === 7">
          <mat-list role="list">
            <mat-list-item role="listitem" class="step-recom-item" *ngFor="let stepRecom of listAllStepRecom" (click)="selectStepRecom(stepRecom)">
              Recommendation {{stepRecom.sn}}
            </mat-list-item>
          </mat-list>
        </div>

      </mat-card-content>
    </mat-card>

  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar class="main-toolbar">
      <!--button class="menu-button" mat-icon-button (click)="sidenav.toggle()"-->

      <div *ngIf="!isLoggedIn" margin-left="10px">
        <span class="span-title">ADORA - DP Trial Suite</span>
      </div>

      <div *ngIf="isLoggedIn">
        <button class="menu-button" mat-mini-fab (click)="toggleSideNave()">
          <mat-icon>menu</mat-icon>
        </button>
      </div>

      <div *ngIf="isLoggedIn">
        <button class="menu-button" mat-mini-fab (click)="homeButtonClicked()">
          <mat-icon>home</mat-icon>
        </button>
      </div>

      <div *ngIf="isLoggedIn && selectedCustomer.id !== 0 && currentModelInSelection > 0">
        <button class="pos-button" id="btnCustomer" mat-raised-button matTooltip="{{selectedCustomer.name}}"
          (click)="customerButtonClicked()">
          {{customerName}}
        </button>
      </div>

      <div *ngIf="isLoggedIn && selectedCustomer.id !== 0 && currentModelInSelection > 1">
        <button class="pos-button" id="btnVessel" mat-raised-button matTooltip="{{selectedVessel.name}}"
          (click)="vesselButtonClicked()">
          {{vesselName}}
        </button>
      </div>

      <div *ngIf="isLoggedIn && selectedCustomer.id !== 0 && currentModelInSelection > 2">
        <button class="pos-button" id="btnTrail" mat-raised-button matTooltip="{{selectedTrail.name}}"
          (click)="trialButtonClicked()">
          {{trailName}}
        </button>
      </div>

      <div *ngIf="isLoggedIn && selectedCustomer.id !== 0 && currentModelInSelection > 3">
        <button class="pos-button" id="btnTest" mat-raised-button matTooltip="{{selectedTest.name}}"
          (click)="testButtonClicked()">
          {{testName}}
        </button>
      </div>

      <div *ngIf="isLoggedIn && selectedCustomer.id !== 0 && currentModelInSelection > 4 && currentModelInSelection !== 6 ">
        <button class="pos-button" id="btnTestStep" mat-raised-button matTooltip="Step #{{selectedTestStep.sn}}"
          (click)="testStepButtonClicked()">
          Step: {{testStepSN}}
        </button>
      </div>

      <div *ngIf="isLoggedIn && selectedCustomer.id !== 0 && currentModelInSelection === 6">
        <button class="pos-button" id="btnRecommendation" mat-raised-button matTooltip="Recommendation {{selectedRecommendation.sn}}"
        (click)="recommendationButtonClicked()">
          Rec. {{recommendationSN}}
        </button>
      </div>

      <div *ngIf="isLoggedIn && selectedCustomer.id !== 0 && currentModelInSelection === 7">
        <button class="pos-button" id="btnStepRecom" mat-raised-button matTooltip="Step Recom. {{selectedStepRecom.sn}}"
        (click)="stepRecomButtonClicked()">
          Rec. {{stepRecomSN}}
        </button>
      </div>

      <span class="example-spacer"></span>

      <div *ngIf="isLoggedIn && currentModelInSelection > 0">
        <mat-button-toggle-group class="btnToggle" (change)="onEditModeChange($event.value)" *ngIf="isWithEditRight">
          <mat-button-toggle value="read" matTooltip="readonly">
              <mat-icon>subject</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="edit" matTooltip="edit mode">
              <mat-icon>edit</mat-icon>
          </mat-button-toggle>
      </mat-button-toggle-group>
      </div>

      <button *ngIf="!isLoggedIn" class="menu-button" mat-mini-fab [matMenuTriggerFor]="menuDownload">
          <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menuDownload="matMenu">
        <button mat-menu-item (click)="download_ADP_manual()">
          <span>ADP使用手册</span>
        </button>
        <button mat-menu-item (click)="download_ADP_apk()">
          <span>ADP手机客户端</span>
        </button>
      </mat-menu>

    </mat-toolbar>

    <router-outlet></router-outlet>

  </mat-sidenav-content>

</mat-sidenav-container>